import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/clinic";
import { Loader2, FileSpreadsheet } from "lucide-react";

export const PlannerViewDialog = ({ open, onOpenChange }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setError("");
    api
      .get("/imports/last")
      .then(({ data }) => setData(data))
      .catch((err) => setError(err?.response?.data?.detail || "Nessun planner importato"))
      .finally(() => setLoading(false));
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-6xl max-h-[92vh] overflow-hidden flex flex-col" data-testid="planner-view-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl tracking-tight">Planner importato</DialogTitle>
          <DialogDescription className="text-sm text-slate-600">
            {data
              ? `${data.filename} · giornata ${data.data || "—"} · ${data.inserted} pazienti importati, ${data.skipped} righe vuote ignorate`
              : "Contenuto dell'ultimo file caricato"}
          </DialogDescription>
        </DialogHeader>

        {loading && (
          <div className="py-16 flex justify-center text-slate-400">
            <Loader2 className="w-6 h-6 animate-spin" />
          </div>
        )}

        {error && !loading && (
          <div className="py-16 text-center text-slate-400" data-testid="planner-view-empty">
            <FileSpreadsheet className="w-8 h-8 mx-auto mb-3" />
            {error}
          </div>
        )}

        {data && !loading && (
          <div className="overflow-auto rounded-xl border border-slate-200" data-testid="planner-view-table">
            <table className="w-full text-left text-xs">
              <thead className="bg-slate-50 border-b border-slate-200 sticky top-0">
                <tr className="uppercase tracking-wider text-slate-500">
                  {data.colonne.map((c) => (
                    <th key={c} className="px-3 py-2 font-semibold whitespace-nowrap">{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.righe.map((r, i) => (
                  <tr key={i} className="border-b border-slate-100 last:border-0 hover:bg-slate-50" data-testid="planner-view-row">
                    {data.colonne.map((c) => (
                      <td key={c} className="px-3 py-2 whitespace-nowrap text-slate-700">{r[c] || ""}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
